import React from 'react';
import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {doppeLockActionTypeCountdown} from './doppe-lock-action-type-countdown';

export const doppeLockActionTypeCountdownViewer = doppeActionTypeDefineViewerMetadata(doppeLockActionTypeCountdown, {

    loadViewerComponents: async () => {
        return {
            DoppeLockActionTypeCountdownWidget: (await import('./doppe-lock-action-type-countdown-widget/doppe-lock-action-type-countdown-widget')).DoppeLockActionTypeCountdownWidget,
        };
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeLockActionTypeCountdownWidget,
        } = viewerComponents;

        return (
            <DoppeLockActionTypeCountdownWidget
                {...renderProps}
            />
        );
    },
});
